/**
 * Stores build information. The string literals are replaces at compile time by `set_version.js`.
 */
export const buildInfo = {
    versionNumber: "0.1.0",
    versionName: "nightly 2024-01-08",
    versionChannel: "nightly",
    buildDate: "2024-01-08T00:15:28.895Z",
    commitHash: "47db84473a639c405289bb86ce238a83af574137",
};
